import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useCancelMySubscription } from "../../../../store/Apis/StripeApi";
import { useDispatch } from "react-redux";
import { changeSubscriptionStatus } from "../../../../store/account/userSlice";
import { ErrorIcon } from "../../../../Custom-imeges/ErrorIcon";
interface CancelModalProps {
  show: boolean;
  handleClose: () => void;
  name: string;
  message?: string;
}
const CancelSubscriptionModal: React.FC<CancelModalProps> = ({
  show,
  message,
  handleClose,
  name,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [confirmCancelSubscription, setConfirmCancelSubscription] = useState<string>("");
  const [showMssError,setShowMsgError] = useState(false);

  const { cancelSubscription, isLoading, error, cancel } =
    useCancelMySubscription();

  const handleCancelSubscription = () => {
    if(confirmCancelSubscription.toLowerCase().trim() === "cancel"){
      cancelSubscription();
    }else {
      setShowMsgError(true);
    }
  };

  useEffect(() => {
    if (isLoading || error) return;
    if (cancel) {
      dispatch(changeSubscriptionStatus(false));
      navigate("/cancel-my-Subscription");
    }
  }, [cancel]);

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && !event.shiftKey) {
      handleCancelSubscription()
    }
  };

  return (
    <Modal className="DeleteModal" show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="clearConPopupHeader border-0">
        <Modal.Title>{name}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={`DeleteModalBody border-0 px-0 py-1 rounded-bottom-4`}>
        <div className="d-flex flex-column align-items-start px-4 py-3">
          <p>
            {message}
          </p>
          <Form.Control
              className="confirmDeleteInput mb-0"
              placeholder="Type 'cancel' in the box to confirm."
              value={confirmCancelSubscription}
              onChange={(e) => setConfirmCancelSubscription(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            {showMssError && confirmCancelSubscription.toLowerCase() !== "cancel" &&
              <div className="match-error-msg">
                <ErrorIcon/>
                <span>Incorrect word.</span>
              </div>
            }
        </div>
        <div className="line popup"></div>
        <div className="d-flex pb-3 pe-3 buttons align-items-center justify-content-end">
          <button className="cancelDeleteBtn mx-2" onClick={handleClose}>
            Discard
          </button>
          <button
            disabled={isLoading || confirmCancelSubscription.toLowerCase().trim() !== "cancel"}
            className="confirmDeleteBtn mx-2"
            style={{
              cursor: confirmCancelSubscription.toLowerCase().trim() !== "cancel" || isLoading ? "default" : "pointer",
              opacity: confirmCancelSubscription.toLowerCase().trim() !== "cancel" || isLoading ? 0.5 : 1,
            }}
            onClick={handleCancelSubscription}
          >
            Cancel subscription
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CancelSubscriptionModal;
